import { gql } from 'apollo-angular';

export const CheckCompanyDataExistDocument = gql`
  mutation checkCompanyDataExist($funnelId: Int!) {
    checkCompanyDataExist(funnelId: $funnelId)
  }
`;
